export const FrankingType = {
  DVFr: 0,
  Envelope: 1
}
